import { render } from "./ReviewsPage.vue?vue&type=template&id=0abb516a&scoped=true"
import script from "./ReviewsPage.vue?vue&type=script&lang=js"
export * from "./ReviewsPage.vue?vue&type=script&lang=js"

import "./ReviewsPage.vue?vue&type=style&index=0&id=0abb516a&lang=css"
import "./ReviewsPage.vue?vue&type=style&index=1&id=0abb516a&lang=css"
import "./ReviewsPage.vue?vue&type=style&index=2&id=0abb516a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abb516a"]])

export default __exports__